import './polyfills';
import { ClientSDKModule } from './client-sdk.module';
import { isSearchEngineCrawler } from './helpers/helpers';
import { TrackingModule } from './modules/tracking/tracking.module';

(function () {
    const obfClient = new ClientSDKModule();
    const trackingModule = new TrackingModule();

    // Google Weblight Version
    if (window.navigator.userAgent.includes('Gecko; googleweblight')) {

        // Set OBF button's href to contact-us on weblight version
        document.addEventListener('DOMContentLoaded', () => {
            const selectors = '[data-book-btn], [data-book-btn] *, [data-free-quote-btn], [data-free-quote-btn] * ';
            const allbuttons = document.querySelectorAll(selectors);
            
            for (let index = 0; index < allbuttons.length; index++) {
                let element: any = allbuttons[index];
                if (element.nodeName === 'A' && element.getAttribute('href') === '#') {
                    element.setAttribute('href', 'contact-us')
                }
            }
        });
    
    // Check for Crawler/Bot
    } else if (!isSearchEngineCrawler() || window.location.origin.includes('localhost')) {

        // Init Tracking script
        trackingModule.initialize();
        
        // Init Client
        obfClient.autoInitClient((obfInstance: any) => {
            window.obfClientSDK = obfInstance;
        });

        
    }
})()

